import React, { useState, useEffect, useRef } from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import styled from "styled-components"
import firebase from "gatsby-plugin-firebase"
import { useAuth } from "gatsby-theme-firebase"
import useTaskUpdate from "../utils/useTaskUpdate"
import { INLINES } from "@contentful/rich-text-types"
import { Link } from "gatsby"
import Modal from "react-responsive-modal"

const website_url = "https://youchangeearth.org"
const options = {
  renderText: text =>
    text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
  renderNode: {
    [INLINES.HYPERLINK]: node => {
      return (
        <a
          href={node.data.uri}
          target={`${
            node.data.uri.startsWith(website_url) ? "_self" : "_blank"
          }`}
          rel={`${
            node.data.uri.startsWith(website_url) ? "" : "noopener noreferrer"
          }`}
          style={{ textDecoration: "none", color: "var(--green)" }}
        >
          {node.content[0].value}
        </a>
      )
    },
  },
}

const modalStyles = {
  modal: {
    borderRadius: "0.45em",
    textAlign: "center",
    maxWidth: "500px",
  },
}

const MainContainer = styled.div`
  display: none;
  transition: box-shadow 0.3s, opacity 0.3s;
  @media (min-width: 500px) {
    display: block;
  }
`

const MainAccordion = styled.div`
  display: block;
  transition: box-shadow 0.3s;
  @media (min-width: 500px) {
    display: none;
  }
`

const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 0.6em;
  background-color: #fff;
  margin-bottom: 1.2em;
  padding: 1.4em;
  justify-items: center;
`

const AccordionSubContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ToggleButton = styled.button`
  background-color: #000000;
  color: #fff;
  border-radius: 0.6em;
  align-items: center;
  border: none;
  padding: 0.5em;
  padding-left: 0.2em;
  display: flex;
  height: 2em;
  cursor: pointer;
`
const AccordionContent = styled.div`
  background-color: #fff;
  overflow: auto;
  transition: max-height 0.6s ease;
`

const AccordionText = styled.div`
  padding: 0.6em;
  margin-bottom: 1em;
`

const ModalDiv = styled.div`
  @media (min-width: 375px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-items: center;
  }
`

const TaskCard = ({
  task,
  dispatch,
  cardType,
  checkCompletion,
  isProjectAdded,
  addProject,
}) => {
  const { isLoggedIn, profile } = useAuth()
  const [currentTask, setCurrentTask] = useState(task)
  const [status, setStatus] = useState()
  const updateTaskWithId = useTaskUpdate()
  const [active, setActive] = useState("")
  const [height, setHeight] = useState("0px")
  const [border, setBorder] = useState("0 3px 6px rgba(0, 0, 0, 0.12)")
  const [opacity, setOpacity] = useState("100%")
  const content = useRef(null)
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const toggleAccordion = () => {
    setActive(active === "" ? "active" : "")
    setHeight(active === "active" ? "0" : `${content.current.scrollHeight}px`)
  }

  useEffect(() => {
    if (isLoggedIn && profile) {
      firebase
        .firestore()
        .collection(process.env.GATSBY_FIRESTORE_USERS)
        .doc(profile.email)
        .get()
        .then(function(doc) {
          if (doc.exists) {
            const tasks = doc.data().tasks
            const temp = currentTask
            tasks.forEach(task => {
              if (task.id == temp.id) {
                temp.status = task.status
                setCurrentTask(temp)
                setStatus(task.status)
                if (temp.status === "pledged") {
                  setBorder("0 0 0 3px rgba(1, 183, 107, 1)")
                  setOpacity("100%")
                } else if (temp.status === "done") {
                  setBorder("0 3px 6px rgba(0, 0, 0, 0.12)")
                  setOpacity("100%")
                }
                if (temp.status === "no") {
                  setBorder("0 3px 6px rgba(0, 0, 0, 0.12)")
                  setOpacity("30%")
                }
                if (cardType === "task") {
                  if (temp.status === "pledged" || temp.status === "done") {
                    dispatch({ type: "done", payload: temp.id })
                  } else if (temp.status === "no") {
                    dispatch({ type: "no", payload: temp.id })
                  }
                }
              }
            })
          }
        })
    }
  }, [currentTask, isLoggedIn, profile])

  const updateTaskStatusState = status => {
    setModalIsOpen(true)
    if (isLoggedIn && profile) {
      if (!isProjectAdded) {
        addProject()
      }
      const temp = currentTask
      temp.status = status
      setCurrentTask(temp)
      setStatus(status)
      console.log(temp.status)
      if (status === "pledged") {
        setBorder("0 0 0 3px rgba(1, 183, 107, 1)")
        setOpacity("100%")
      } else if (status === "no") {
        setBorder("0 3px 6px rgba(0, 0, 0, 0.12)")
        setOpacity("30%")
      } else {
        setBorder("0 3px 6px rgba(0, 0, 0, 0.12)")
        setOpacity("100%")
      }

      if (cardType === "task") {
        if (status === "pledged" || status === "done") {
          dispatch({ type: "done", payload: temp.id })
        } else if (temp.status === "no") {
          dispatch({ type: "no", payload: temp.id })
        }
        checkCompletion()
      }
    }
  }

  return (
    <div>
      {!isLoggedIn && (
        <Modal
          open={modalIsOpen}
          onClose={() => {
            setModalIsOpen(false)
          }}
          center
          styles={modalStyles}
        >
          <h1
            style={{
              fontWeight: "600",
              fontSize: "1.3rem",
              marginBottom: "2rem",
            }}
          >
            Track progress in your dashboard
          </h1>
          <p style={{ marginBottom: "2rem" }}>
            Ah, these pages are 'read-only.' You can create your tailored
            dashboard and get rewarded by going through our personal climate
            plan.
          </p>
          <ModalDiv>
            <button
              style={{ marginBottom: "1rem" }}
              onClick={() => setModalIsOpen(false)}
            >
              <p style={{ fontWeight: "600", outline: "none" }}>
                Not right now
              </p>
            </button>
            <Link to="/mainform" style={{ textDecoration: "none" }}>
              <div
                className="button homepageButton"
                style={{
                  width: "12rem",
                  color: "white",
                  textAlign: "center",
                  textDecoration: "none",
                }}
              >
                <p
                  style={{
                    fontSize: "0.9rem",
                    fontWeight: 700,
                    textDecoration: "none",
                  }}
                >
                  GET STARTED
                </p>
              </div>
            </Link>
          </ModalDiv>
        </Modal>
      )}
      <MainContainer
        style={{
          backgroundColor: "#fff",
          borderRadius: "0.6em",
          padding: "2em 6em 2em 6em",
          marginBottom: "2em",
          minWidth: "0",
          boxShadow: `${border}`,
          opacity: `${opacity}`,
        }}
      >
        {currentTask.name && (
          <h4 className="text-xl font-medium pb-2 mb-4">{currentTask.name}</h4>
        )}
        {currentTask.title && (
          <h4 className="text-xl font-medium pb-2 mb-4">{currentTask.title}</h4>
        )}
        <div className="text-gray-700">
          {currentTask.description && (
            <div>
              {documentToReactComponents(currentTask.description.json, options)}
              <br />
            </div>
          )}
        </div>
        <p>
          <b>Action:</b>{" "}
          {documentToReactComponents(currentTask.toDo.json, options)}
        </p>
        <br />
        <div style={{ display: "flex" }}>
          {status === "done" ? (
            <button
              type="button"
              onClick={() => {
                updateTaskWithId(currentTask.id, "done")
                updateTaskStatusState("done")
              }}
              style={{
                borderRadius: "0.5em",
                border: "3px solid var(--green)",
                transition: "border 0.5s, color 0.5s",
                outline: "none",
                width: "9em",
                height: "2.8em",
                marginRight: "1em",
                marginBottom: "1em",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="15px"
                  height="15px"
                  viewBox="0 0 475.099 475.099"
                  xmlSpace="preserve"
                >
                  <g>
                    <path d="M442.829,265.532c9.328-14.089,13.986-29.598,13.986-46.538c0-19.607-7.225-36.637-21.687-51.117 c-14.469-14.465-31.601-21.696-51.394-21.696h-50.251c9.134-18.842,13.709-37.117,13.709-54.816c0-22.271-3.34-39.971-9.996-53.105 c-6.663-13.138-16.372-22.795-29.126-28.984C295.313,3.09,280.947,0,264.959,0c-9.712,0-18.274,3.521-25.697,10.566 c-8.183,7.993-14.084,18.274-17.699,30.837c-3.617,12.559-6.521,24.6-8.708,36.116c-2.187,11.515-5.569,19.652-10.135,24.41 c-9.329,10.088-19.511,22.273-30.551,36.547c-19.224,24.932-32.264,39.685-39.113,44.255H54.828 c-10.088,0-18.702,3.574-25.84,10.706c-7.135,7.139-10.705,15.752-10.705,25.841v182.723c0,10.089,3.566,18.699,10.705,25.838 c7.142,7.139,15.752,10.711,25.84,10.711h82.221c4.188,0,17.319,3.806,39.399,11.42c23.413,8.186,44.017,14.418,61.812,18.702 c17.797,4.284,35.832,6.427,54.106,6.427h26.545h10.284c26.836,0,48.438-7.666,64.809-22.99 c16.365-15.324,24.458-36.213,24.27-62.67c11.42-14.657,17.129-31.597,17.129-50.819c0-4.185-0.281-8.277-0.855-12.278 c7.23-12.748,10.854-26.453,10.854-41.11C445.399,278.379,444.544,271.809,442.829,265.532z M85.949,396.58 c-3.616,3.614-7.898,5.428-12.847,5.428c-4.95,0-9.233-1.813-12.85-5.428c-3.615-3.613-5.424-7.897-5.424-12.85 c0-4.948,1.805-9.229,5.424-12.847c3.621-3.617,7.9-5.425,12.85-5.425c4.949,0,9.231,1.808,12.847,5.425 c3.617,3.617,5.426,7.898,5.426,12.847C91.375,388.683,89.566,392.967,85.949,396.58z M414.145,242.419 c-4.093,8.754-9.186,13.227-15.276,13.415c2.854,3.237,5.235,7.762,7.139,13.562c1.902,5.807,2.847,11.087,2.847,15.848 c0,13.127-5.037,24.455-15.126,33.969c3.43,6.088,5.141,12.658,5.141,19.697c0,7.043-1.663,14.038-4.996,20.984 c-3.327,6.94-7.851,11.938-13.559,14.982c0.951,5.709,1.423,11.04,1.423,15.988c0,31.785-18.274,47.678-54.823,47.678h-34.536 c-24.94,0-57.483-6.943-97.648-20.841c-0.953-0.38-3.709-1.383-8.28-2.998s-7.948-2.806-10.138-3.565 c-2.19-0.767-5.518-1.861-9.994-3.285c-4.475-1.431-8.087-2.479-10.849-3.142c-2.758-0.664-5.901-1.283-9.419-1.855 c-3.52-0.571-6.519-0.855-8.993-0.855h-9.136V219.285h9.136c3.045,0,6.423-0.859,10.135-2.568c3.711-1.714,7.52-4.283,11.421-7.71 c3.903-3.427,7.564-6.805,10.992-10.138c3.427-3.33,7.233-7.517,11.422-12.559c4.187-5.046,7.47-9.089,9.851-12.135 c2.378-3.045,5.375-6.949,8.992-11.707c3.615-4.757,5.806-7.613,6.567-8.566c10.467-12.941,17.795-21.601,21.982-25.981 c7.804-8.182,13.466-18.603,16.987-31.261c3.525-12.66,6.427-24.604,8.703-35.832c2.282-11.229,5.903-19.321,10.858-24.27 c18.268,0,30.453,4.471,36.542,13.418c6.088,8.945,9.134,22.746,9.134,41.399c0,11.229-4.572,26.503-13.71,45.821 c-9.134,19.32-13.698,34.5-13.698,45.539h100.495c9.527,0,17.993,3.662,25.413,10.994c7.426,7.327,11.143,15.843,11.143,25.553 C420.284,225.943,418.237,233.653,414.145,242.419z" />
                  </g>
                </svg>
                <p
                  style={{
                    margin: "0.4rem 0.5rem",
                  }}
                >
                  <b>I do this</b>
                </p>
              </div>
            </button>
          ) : (
            <button
              type="button"
              onClick={() => {
                updateTaskWithId(currentTask.id, "done")
                updateTaskStatusState("done")
              }}
              style={{
                borderRadius: "0.5em",
                border: "none",
                border: "3px solid #dddddd",
                transition: "border 0.5s, color 0.5s",
                outline: "none",
                width: "9em",
                height: "2.8em",
                marginRight: "1em",
                marginBottom: "1em",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="15px"
                  height="15px"
                  viewBox="0 0 475.099 475.099"
                  xmlSpace="preserve"
                >
                  <g>
                    <path d="M442.829,265.532c9.328-14.089,13.986-29.598,13.986-46.538c0-19.607-7.225-36.637-21.687-51.117 c-14.469-14.465-31.601-21.696-51.394-21.696h-50.251c9.134-18.842,13.709-37.117,13.709-54.816c0-22.271-3.34-39.971-9.996-53.105 c-6.663-13.138-16.372-22.795-29.126-28.984C295.313,3.09,280.947,0,264.959,0c-9.712,0-18.274,3.521-25.697,10.566 c-8.183,7.993-14.084,18.274-17.699,30.837c-3.617,12.559-6.521,24.6-8.708,36.116c-2.187,11.515-5.569,19.652-10.135,24.41 c-9.329,10.088-19.511,22.273-30.551,36.547c-19.224,24.932-32.264,39.685-39.113,44.255H54.828 c-10.088,0-18.702,3.574-25.84,10.706c-7.135,7.139-10.705,15.752-10.705,25.841v182.723c0,10.089,3.566,18.699,10.705,25.838 c7.142,7.139,15.752,10.711,25.84,10.711h82.221c4.188,0,17.319,3.806,39.399,11.42c23.413,8.186,44.017,14.418,61.812,18.702 c17.797,4.284,35.832,6.427,54.106,6.427h26.545h10.284c26.836,0,48.438-7.666,64.809-22.99 c16.365-15.324,24.458-36.213,24.27-62.67c11.42-14.657,17.129-31.597,17.129-50.819c0-4.185-0.281-8.277-0.855-12.278 c7.23-12.748,10.854-26.453,10.854-41.11C445.399,278.379,444.544,271.809,442.829,265.532z M85.949,396.58 c-3.616,3.614-7.898,5.428-12.847,5.428c-4.95,0-9.233-1.813-12.85-5.428c-3.615-3.613-5.424-7.897-5.424-12.85 c0-4.948,1.805-9.229,5.424-12.847c3.621-3.617,7.9-5.425,12.85-5.425c4.949,0,9.231,1.808,12.847,5.425 c3.617,3.617,5.426,7.898,5.426,12.847C91.375,388.683,89.566,392.967,85.949,396.58z M414.145,242.419 c-4.093,8.754-9.186,13.227-15.276,13.415c2.854,3.237,5.235,7.762,7.139,13.562c1.902,5.807,2.847,11.087,2.847,15.848 c0,13.127-5.037,24.455-15.126,33.969c3.43,6.088,5.141,12.658,5.141,19.697c0,7.043-1.663,14.038-4.996,20.984 c-3.327,6.94-7.851,11.938-13.559,14.982c0.951,5.709,1.423,11.04,1.423,15.988c0,31.785-18.274,47.678-54.823,47.678h-34.536 c-24.94,0-57.483-6.943-97.648-20.841c-0.953-0.38-3.709-1.383-8.28-2.998s-7.948-2.806-10.138-3.565 c-2.19-0.767-5.518-1.861-9.994-3.285c-4.475-1.431-8.087-2.479-10.849-3.142c-2.758-0.664-5.901-1.283-9.419-1.855 c-3.52-0.571-6.519-0.855-8.993-0.855h-9.136V219.285h9.136c3.045,0,6.423-0.859,10.135-2.568c3.711-1.714,7.52-4.283,11.421-7.71 c3.903-3.427,7.564-6.805,10.992-10.138c3.427-3.33,7.233-7.517,11.422-12.559c4.187-5.046,7.47-9.089,9.851-12.135 c2.378-3.045,5.375-6.949,8.992-11.707c3.615-4.757,5.806-7.613,6.567-8.566c10.467-12.941,17.795-21.601,21.982-25.981 c7.804-8.182,13.466-18.603,16.987-31.261c3.525-12.66,6.427-24.604,8.703-35.832c2.282-11.229,5.903-19.321,10.858-24.27 c18.268,0,30.453,4.471,36.542,13.418c6.088,8.945,9.134,22.746,9.134,41.399c0,11.229-4.572,26.503-13.71,45.821 c-9.134,19.32-13.698,34.5-13.698,45.539h100.495c9.527,0,17.993,3.662,25.413,10.994c7.426,7.327,11.143,15.843,11.143,25.553 C420.284,225.943,418.237,233.653,414.145,242.419z" />
                  </g>
                </svg>
                <p
                  style={{
                    margin: "0.4rem 0.5rem",
                  }}
                >
                  <b>I do this</b>
                </p>
              </div>
            </button>
          )}
          {status === "pledged" ? (
            <button
              type="button"
              onClick={() => {
                updateTaskWithId(currentTask.id, "pledged")
                updateTaskStatusState("pledged")
              }}
              style={{
                borderRadius: "0.5em",
                border: "none",
                width: "9em",
                height: "2.8em",
                marginRight: "1em",
                marginBottom: "1em",
                backgroundColor: "var(--green)",
                transition: "background-color 0.5s, color 0.5s",
                outline: "none",
                color: "white",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <svg
                  width="11"
                  height="8"
                  viewBox="0 0 11 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.7406 1.51333L4.57173 7.74C4.22825 8.08667 3.67868 8.08667 3.3352 7.74L0.257611 4.60667C-0.0858702 4.26 -0.0858702 3.7 0.257611 3.35333C0.601092 3.00667 1.15066 3.00667 1.49414 3.35333L3.9672 5.86L9.51785 0.26C9.86133 -0.0866667 10.4109 -0.0866667 10.7544 0.26C11.0841 0.606667 11.0841 1.16667 10.7406 1.51333Z"
                    fill="white"
                    style={{ transition: "fill 0.5s" }}
                  />
                </svg>
                <p
                  style={{
                    margin: "0.4rem 0.5rem",
                  }}
                >
                  <b>Pledge</b>
                </p>
              </div>
            </button>
          ) : (
            <button
              type="button"
              onClick={() => {
                updateTaskWithId(currentTask.id, "pledged")
                updateTaskStatusState("pledged")
              }}
              style={{
                borderRadius: "0.5em",
                border: "none",
                width: "9em",
                height: "2.8em",
                marginRight: "1em",
                marginBottom: "1em",
                backgroundColor: "#dddddd",
                transition: "background-color 0.5s, color 0.5s",
                outline: "none",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <svg
                  width="11"
                  height="8"
                  viewBox="0 0 11 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.7406 1.51333L4.57173 7.74C4.22825 8.08667 3.67868 8.08667 3.3352 7.74L0.257611 4.60667C-0.0858702 4.26 -0.0858702 3.7 0.257611 3.35333C0.601092 3.00667 1.15066 3.00667 1.49414 3.35333L3.9672 5.86L9.51785 0.26C9.86133 -0.0866667 10.4109 -0.0866667 10.7544 0.26C11.0841 0.606667 11.0841 1.16667 10.7406 1.51333Z"
                    fill="black"
                    style={{ transition: "fill 0.5s" }}
                  />
                </svg>
                <p
                  style={{
                    margin: "0.4rem 0.5rem",
                  }}
                >
                  <b>Pledge</b>
                </p>
              </div>
            </button>
          )}
          <button
            type="button"
            onClick={() => {
              updateTaskWithId(currentTask.id, "no")
              updateTaskStatusState("no")
            }}
            style={{
              borderRadius: "0.5em",
              border: "none",
              border: "3px solid #dddddd",
              width: "9em",
              height: "2.8em",
              marginRight: "1em",
              marginBottom: "1em",
              textAlign: "center",
              cursor: "pointer",
              outline: "none",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <svg
                width="11"
                height="11"
                viewBox="0 0 11 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                // style={{ marginTop: "auto" }}
              >
                <path
                  d="M9.19172 0.926367L9.19157 0.926193L9.18388 0.933879L5.58142 4.53634C5.52704 4.59072 5.45816 4.57917 5.42609 4.54418L5.42627 4.54402L5.41858 4.53634L1.81612 0.933879C1.57666 0.694417 1.18119 0.68175 0.942366 0.937719C0.706737 1.1774 0.695423 1.56957 0.94952 1.80717L4.54863 5.40628C4.60301 5.46066 4.59146 5.52955 4.55648 5.56161L4.55632 5.56144L4.54863 5.56912L0.933879 9.18388C0.69442 9.42334 0.68175 9.81879 0.937709 10.0576C1.17738 10.2933 1.56956 10.3046 1.80717 10.0505L5.40628 6.45137C5.46066 6.39699 5.52955 6.40854 5.56161 6.44352L5.56144 6.44368L5.56912 6.45137L9.18388 10.0661C9.42334 10.3056 9.81878 10.3183 10.0576 10.0623C10.2932 9.82274 10.3046 9.4308 10.0508 9.19316L6.46427 5.58202L6.46366 5.58142C6.40928 5.52704 6.42083 5.45816 6.45582 5.42609L6.45598 5.42627L6.46366 5.41858L10.0661 1.81612C10.3056 1.57667 10.3182 1.18122 10.0623 0.942389C9.8181 0.702176 9.43475 0.703592 9.19172 0.926367Z"
                  fill="#1C261E"
                  stroke="black"
                  stroke-width="0.5"
                />
              </svg>
              <p
                style={{
                  margin: "0.4rem 0.5rem",
                  fontSize: "0.75rem",
                }}
              >
                <b>Not Applicable</b>
              </p>
            </div>
          </button>
        </div>
      </MainContainer>

      <MainAccordion>
        <div>
          <AccordionContainer
            style={{
              boxShadow: `${border}`,
              opacity: `${opacity}`,
              transition: "box-shadow 0.3s, opacity 0.3s",
            }}
          >
            <AccordionSubContainer>
              <p
                style={{
                  marginBottom: "0",
                }}
              >
                <b>{task.name}</b>
              </p>
              {!active && (
                <ToggleButton onClick={toggleAccordion}>
                  <p
                    style={{
                      marginBottom: "0",
                      marginRight: "0.5em",
                      marginLeft: "10px",
                    }}
                  >
                    VIEW
                  </p>
                  <div
                    style={{
                      marginLeft: "auto",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      width={10}
                      fill={"#777"}
                      dir="down"
                    >
                      <path
                        fill="currentColor"
                        d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                      ></path>
                    </svg>
                  </div>
                </ToggleButton>
              )}
              {active && (
                <ToggleButton
                  onClick={toggleAccordion}
                  style={{ width: "5.8em" }}
                >
                  <p
                    style={{
                      marginBottom: "0",
                      marginRight: "0.5em",
                      marginLeft: "10px",
                    }}
                  >
                    CLOSE
                  </p>
                  <div
                    style={{
                      marginLeft: "auto",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      width={10}
                      fill={"#777"}
                      dir="up"
                    >
                      <path
                        fill="currentColor"
                        d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                      ></path>
                    </svg>
                  </div>
                </ToggleButton>
              )}
            </AccordionSubContainer>
            <br />
            <AccordionContent ref={content} style={{ maxHeight: `${height}` }}>
              <AccordionText>
                {task.description && (
                  <div
                    style={{
                      marginBottom: "1rem",
                    }}
                  >
                    {documentToReactComponents(task.description.json, options)}
                  </div>
                )}
                <p>
                  <b>Action:</b>{" "}
                  {documentToReactComponents(task.toDo.json, options)}
                </p>
              </AccordionText>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  padding: "1em 2em 0 2em",
                }}
              >
                {status === "done" ? (
                  <button
                    type="button"
                    onClick={() => {
                      updateTaskWithId(currentTask.id, "done")
                      updateTaskStatusState("done")
                    }}
                    style={{
                      borderRadius: "0.5em",
                      border: "3px solid var(--green)",
                      transition: "border 0.5s, color 0.5s",
                      outline: "none",
                      width: "9em",
                      height: "2.8em",
                      marginRight: "1em",
                      marginBottom: "1em",
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="15px"
                        height="15px"
                        viewBox="0 0 475.099 475.099"
                        xmlSpace="preserve"
                      >
                        <g>
                          <path d="M442.829,265.532c9.328-14.089,13.986-29.598,13.986-46.538c0-19.607-7.225-36.637-21.687-51.117 c-14.469-14.465-31.601-21.696-51.394-21.696h-50.251c9.134-18.842,13.709-37.117,13.709-54.816c0-22.271-3.34-39.971-9.996-53.105 c-6.663-13.138-16.372-22.795-29.126-28.984C295.313,3.09,280.947,0,264.959,0c-9.712,0-18.274,3.521-25.697,10.566 c-8.183,7.993-14.084,18.274-17.699,30.837c-3.617,12.559-6.521,24.6-8.708,36.116c-2.187,11.515-5.569,19.652-10.135,24.41 c-9.329,10.088-19.511,22.273-30.551,36.547c-19.224,24.932-32.264,39.685-39.113,44.255H54.828 c-10.088,0-18.702,3.574-25.84,10.706c-7.135,7.139-10.705,15.752-10.705,25.841v182.723c0,10.089,3.566,18.699,10.705,25.838 c7.142,7.139,15.752,10.711,25.84,10.711h82.221c4.188,0,17.319,3.806,39.399,11.42c23.413,8.186,44.017,14.418,61.812,18.702 c17.797,4.284,35.832,6.427,54.106,6.427h26.545h10.284c26.836,0,48.438-7.666,64.809-22.99 c16.365-15.324,24.458-36.213,24.27-62.67c11.42-14.657,17.129-31.597,17.129-50.819c0-4.185-0.281-8.277-0.855-12.278 c7.23-12.748,10.854-26.453,10.854-41.11C445.399,278.379,444.544,271.809,442.829,265.532z M85.949,396.58 c-3.616,3.614-7.898,5.428-12.847,5.428c-4.95,0-9.233-1.813-12.85-5.428c-3.615-3.613-5.424-7.897-5.424-12.85 c0-4.948,1.805-9.229,5.424-12.847c3.621-3.617,7.9-5.425,12.85-5.425c4.949,0,9.231,1.808,12.847,5.425 c3.617,3.617,5.426,7.898,5.426,12.847C91.375,388.683,89.566,392.967,85.949,396.58z M414.145,242.419 c-4.093,8.754-9.186,13.227-15.276,13.415c2.854,3.237,5.235,7.762,7.139,13.562c1.902,5.807,2.847,11.087,2.847,15.848 c0,13.127-5.037,24.455-15.126,33.969c3.43,6.088,5.141,12.658,5.141,19.697c0,7.043-1.663,14.038-4.996,20.984 c-3.327,6.94-7.851,11.938-13.559,14.982c0.951,5.709,1.423,11.04,1.423,15.988c0,31.785-18.274,47.678-54.823,47.678h-34.536 c-24.94,0-57.483-6.943-97.648-20.841c-0.953-0.38-3.709-1.383-8.28-2.998s-7.948-2.806-10.138-3.565 c-2.19-0.767-5.518-1.861-9.994-3.285c-4.475-1.431-8.087-2.479-10.849-3.142c-2.758-0.664-5.901-1.283-9.419-1.855 c-3.52-0.571-6.519-0.855-8.993-0.855h-9.136V219.285h9.136c3.045,0,6.423-0.859,10.135-2.568c3.711-1.714,7.52-4.283,11.421-7.71 c3.903-3.427,7.564-6.805,10.992-10.138c3.427-3.33,7.233-7.517,11.422-12.559c4.187-5.046,7.47-9.089,9.851-12.135 c2.378-3.045,5.375-6.949,8.992-11.707c3.615-4.757,5.806-7.613,6.567-8.566c10.467-12.941,17.795-21.601,21.982-25.981 c7.804-8.182,13.466-18.603,16.987-31.261c3.525-12.66,6.427-24.604,8.703-35.832c2.282-11.229,5.903-19.321,10.858-24.27 c18.268,0,30.453,4.471,36.542,13.418c6.088,8.945,9.134,22.746,9.134,41.399c0,11.229-4.572,26.503-13.71,45.821 c-9.134,19.32-13.698,34.5-13.698,45.539h100.495c9.527,0,17.993,3.662,25.413,10.994c7.426,7.327,11.143,15.843,11.143,25.553 C420.284,225.943,418.237,233.653,414.145,242.419z" />
                        </g>
                      </svg>
                      <p
                        style={{
                          margin: "0.4rem 0.5rem",
                        }}
                      >
                        <b>I do this</b>
                      </p>
                    </div>
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => {
                      updateTaskWithId(currentTask.id, "done")
                      updateTaskStatusState("done")
                    }}
                    style={{
                      borderRadius: "0.5em",
                      border: "none",
                      border: "3px solid #dddddd",
                      transition: "border 0.5s, color 0.5s",
                      outline: "none",
                      width: "9em",
                      height: "2.8em",
                      marginRight: "1em",
                      marginBottom: "1em",
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="15px"
                        height="15px"
                        viewBox="0 0 475.099 475.099"
                        xmlSpace="preserve"
                      >
                        <g>
                          <path d="M442.829,265.532c9.328-14.089,13.986-29.598,13.986-46.538c0-19.607-7.225-36.637-21.687-51.117 c-14.469-14.465-31.601-21.696-51.394-21.696h-50.251c9.134-18.842,13.709-37.117,13.709-54.816c0-22.271-3.34-39.971-9.996-53.105 c-6.663-13.138-16.372-22.795-29.126-28.984C295.313,3.09,280.947,0,264.959,0c-9.712,0-18.274,3.521-25.697,10.566 c-8.183,7.993-14.084,18.274-17.699,30.837c-3.617,12.559-6.521,24.6-8.708,36.116c-2.187,11.515-5.569,19.652-10.135,24.41 c-9.329,10.088-19.511,22.273-30.551,36.547c-19.224,24.932-32.264,39.685-39.113,44.255H54.828 c-10.088,0-18.702,3.574-25.84,10.706c-7.135,7.139-10.705,15.752-10.705,25.841v182.723c0,10.089,3.566,18.699,10.705,25.838 c7.142,7.139,15.752,10.711,25.84,10.711h82.221c4.188,0,17.319,3.806,39.399,11.42c23.413,8.186,44.017,14.418,61.812,18.702 c17.797,4.284,35.832,6.427,54.106,6.427h26.545h10.284c26.836,0,48.438-7.666,64.809-22.99 c16.365-15.324,24.458-36.213,24.27-62.67c11.42-14.657,17.129-31.597,17.129-50.819c0-4.185-0.281-8.277-0.855-12.278 c7.23-12.748,10.854-26.453,10.854-41.11C445.399,278.379,444.544,271.809,442.829,265.532z M85.949,396.58 c-3.616,3.614-7.898,5.428-12.847,5.428c-4.95,0-9.233-1.813-12.85-5.428c-3.615-3.613-5.424-7.897-5.424-12.85 c0-4.948,1.805-9.229,5.424-12.847c3.621-3.617,7.9-5.425,12.85-5.425c4.949,0,9.231,1.808,12.847,5.425 c3.617,3.617,5.426,7.898,5.426,12.847C91.375,388.683,89.566,392.967,85.949,396.58z M414.145,242.419 c-4.093,8.754-9.186,13.227-15.276,13.415c2.854,3.237,5.235,7.762,7.139,13.562c1.902,5.807,2.847,11.087,2.847,15.848 c0,13.127-5.037,24.455-15.126,33.969c3.43,6.088,5.141,12.658,5.141,19.697c0,7.043-1.663,14.038-4.996,20.984 c-3.327,6.94-7.851,11.938-13.559,14.982c0.951,5.709,1.423,11.04,1.423,15.988c0,31.785-18.274,47.678-54.823,47.678h-34.536 c-24.94,0-57.483-6.943-97.648-20.841c-0.953-0.38-3.709-1.383-8.28-2.998s-7.948-2.806-10.138-3.565 c-2.19-0.767-5.518-1.861-9.994-3.285c-4.475-1.431-8.087-2.479-10.849-3.142c-2.758-0.664-5.901-1.283-9.419-1.855 c-3.52-0.571-6.519-0.855-8.993-0.855h-9.136V219.285h9.136c3.045,0,6.423-0.859,10.135-2.568c3.711-1.714,7.52-4.283,11.421-7.71 c3.903-3.427,7.564-6.805,10.992-10.138c3.427-3.33,7.233-7.517,11.422-12.559c4.187-5.046,7.47-9.089,9.851-12.135 c2.378-3.045,5.375-6.949,8.992-11.707c3.615-4.757,5.806-7.613,6.567-8.566c10.467-12.941,17.795-21.601,21.982-25.981 c7.804-8.182,13.466-18.603,16.987-31.261c3.525-12.66,6.427-24.604,8.703-35.832c2.282-11.229,5.903-19.321,10.858-24.27 c18.268,0,30.453,4.471,36.542,13.418c6.088,8.945,9.134,22.746,9.134,41.399c0,11.229-4.572,26.503-13.71,45.821 c-9.134,19.32-13.698,34.5-13.698,45.539h100.495c9.527,0,17.993,3.662,25.413,10.994c7.426,7.327,11.143,15.843,11.143,25.553 C420.284,225.943,418.237,233.653,414.145,242.419z" />
                        </g>
                      </svg>
                      <p
                        style={{
                          margin: "0.4rem 0.5rem",
                        }}
                      >
                        <b>I do this</b>
                      </p>
                    </div>
                  </button>
                )}
                {status === "pledged" ? (
                  <button
                    type="button"
                    onClick={() => {
                      updateTaskWithId(currentTask.id, "pledged")
                      updateTaskStatusState("pledged")
                    }}
                    style={{
                      borderRadius: "0.5em",
                      border: "none",
                      width: "9em",
                      height: "2.8em",
                      marginRight: "1em",
                      marginBottom: "1em",
                      backgroundColor: "var(--green)",
                      transition: "background-color 0.5s, color 0.5s",
                      outline: "none",
                      color: "white",
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <svg
                        width="11"
                        height="8"
                        viewBox="0 0 11 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10.7406 1.51333L4.57173 7.74C4.22825 8.08667 3.67868 8.08667 3.3352 7.74L0.257611 4.60667C-0.0858702 4.26 -0.0858702 3.7 0.257611 3.35333C0.601092 3.00667 1.15066 3.00667 1.49414 3.35333L3.9672 5.86L9.51785 0.26C9.86133 -0.0866667 10.4109 -0.0866667 10.7544 0.26C11.0841 0.606667 11.0841 1.16667 10.7406 1.51333Z"
                          fill="white"
                          style={{ transition: "fill 0.5s" }}
                        />
                      </svg>
                      <p
                        style={{
                          margin: "0.4rem 0.5rem",
                        }}
                      >
                        <b>Pledge</b>
                      </p>
                    </div>
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => {
                      updateTaskWithId(currentTask.id, "pledged")
                      updateTaskStatusState("pledged")
                    }}
                    style={{
                      borderRadius: "0.5em",
                      border: "none",
                      width: "9em",
                      height: "2.8em",
                      marginRight: "1em",
                      marginBottom: "1em",
                      backgroundColor: "#dddddd",
                      transition: "background-color 0.5s, color 0.5s",
                      outline: "none",
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <svg
                        width="11"
                        height="8"
                        viewBox="0 0 11 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10.7406 1.51333L4.57173 7.74C4.22825 8.08667 3.67868 8.08667 3.3352 7.74L0.257611 4.60667C-0.0858702 4.26 -0.0858702 3.7 0.257611 3.35333C0.601092 3.00667 1.15066 3.00667 1.49414 3.35333L3.9672 5.86L9.51785 0.26C9.86133 -0.0866667 10.4109 -0.0866667 10.7544 0.26C11.0841 0.606667 11.0841 1.16667 10.7406 1.51333Z"
                          fill="black"
                          style={{ transition: "fill 0.5s" }}
                        />
                      </svg>
                      <p
                        style={{
                          margin: "0.4rem 0.5rem",
                        }}
                      >
                        <b>Pledge</b>
                      </p>
                    </div>
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => {
                    updateTaskWithId(currentTask.id, "no")
                    updateTaskStatusState("no")
                  }}
                  style={{
                    borderRadius: "0.5em",
                    border: "none",
                    border: "3px solid #dddddd",
                    width: "9em",
                    height: "2.8em",
                    marginRight: "1em",
                    marginBottom: "1em",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      width="11"
                      height="11"
                      viewBox="0 0 11 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      // style={{ marginTop: "auto" }}
                    >
                      <path
                        d="M9.19172 0.926367L9.19157 0.926193L9.18388 0.933879L5.58142 4.53634C5.52704 4.59072 5.45816 4.57917 5.42609 4.54418L5.42627 4.54402L5.41858 4.53634L1.81612 0.933879C1.57666 0.694417 1.18119 0.68175 0.942366 0.937719C0.706737 1.1774 0.695423 1.56957 0.94952 1.80717L4.54863 5.40628C4.60301 5.46066 4.59146 5.52955 4.55648 5.56161L4.55632 5.56144L4.54863 5.56912L0.933879 9.18388C0.69442 9.42334 0.68175 9.81879 0.937709 10.0576C1.17738 10.2933 1.56956 10.3046 1.80717 10.0505L5.40628 6.45137C5.46066 6.39699 5.52955 6.40854 5.56161 6.44352L5.56144 6.44368L5.56912 6.45137L9.18388 10.0661C9.42334 10.3056 9.81878 10.3183 10.0576 10.0623C10.2932 9.82274 10.3046 9.4308 10.0508 9.19316L6.46427 5.58202L6.46366 5.58142C6.40928 5.52704 6.42083 5.45816 6.45582 5.42609L6.45598 5.42627L6.46366 5.41858L10.0661 1.81612C10.3056 1.57667 10.3182 1.18122 10.0623 0.942389C9.8181 0.702176 9.43475 0.703592 9.19172 0.926367Z"
                        fill="#1C261E"
                        stroke="black"
                        stroke-width="0.5"
                      />
                    </svg>
                    <p
                      style={{
                        margin: "0.4rem 0.5rem",
                        fontSize: "0.75rem",
                      }}
                    >
                      <b>Not Applicable</b>
                    </p>
                  </div>
                </button>
              </div>
            </AccordionContent>
          </AccordionContainer>
        </div>
      </MainAccordion>
    </div>
  )
}

export default TaskCard
